module.exports = __webpack_public_path__ + "img/appStore.b3b23d87.png";